import { Component, OnInit, inject } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'

import { Environment } from '@cyborg-monorepo/hunter/common'
import { DialogRef, DialogService } from '@hyperkit'

import { EnvironmentService } from '../../../../shared/services/environment.service'

@Component({
  standalone: false,
  selector: 'new-environment-dialog',
  templateUrl: './new-environment-dialog.component.html',
  styleUrls: ['./new-environment-dialog.component.scss'],
})
export class NewEnvironmentDialogComponent implements OnInit {
  dialogRef = inject(DialogRef)
  private formBuilder = inject(FormBuilder)
  dialogService = inject(DialogService)
  environmentService = inject(EnvironmentService)

  public formGroup: FormGroup
  public error: string

  public ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
      name: ['', Validators.required],
      description: [''],
    })
  }

  public onSubmit(): void {
    const environment: Environment = this.formGroup.value
    this.environmentService.createEnvironment(environment).subscribe(
      (environment: Environment) => {
        this.dialogRef.close(environment)
      },
      (error) => {
        this.error = error.message
      },
    )
  }

  public onClose(): void {
    this.dialogRef.close()
  }
}
